import React from "react";
import CTA from "../components/CTA";

const ContactPage: React.FC = () => <CTA />;

export default ContactPage;
